import * as React from "react";
import { forwardRef } from "react";
const SvgIconSources = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.39282 3.25H11.6071M1.39282 6.03571H7.89282M1.39282 8.82143H6.03568", stroke: "#787878", strokeWidth: 1.3, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgIconSources);
export default ForwardRef;
